import { Button, Grid } from "@mui/material";
import { Box } from "@mui/system";
import React from "react";
import CommonInput from "../CommonInput";
import { useState } from "react";
import CustomSelect from "../Select/CustomSelect";
import { useEffect } from "react";
import useToaster from "../../customHook/useToaster";
import { regulatoryDetailsPostApi } from "../../Services/caseManagement.service";
import { useSelector } from "react-redux";

const inputFieldNames = {
  "Ground of Fraud Rejection": "ground_of_fraud_rejection",
  "Fraud Committed by": "fraud_committed_by",
  "Name of Susptect/Fraudster": "name_of_suspect",
  "Suspect/ Fraudster ID Proof Name": "suspect_idproof_name",
  "Suspect/ Fraudster ID Proof Number": "suspect_idproof_number",
  "Investigation Agency Name": "investigation_agency_name",
  "Investigaton Propriete Name": "investigation_propriete_name",
  "Investigator PAN Card": "investigator_pan_card",
  "Investigator GSTN Number": "investigator_gst_num",
};
const selectFields = ["Fraud Committed by", "Suspect/ Fraudster ID Proof Name"];
const selectFieldsOptions = {
  "Fraud Committed by": [
    "Claimant",
    "Hospital",
    "Doctor",
    "Diagnostic Center",
    "Pathologist",
    "Intermediary",
    "Agency",
    "Investigator",
  ],
  "Suspect/ Fraudster ID Proof Name": [
    "Pan Card",
    "Passport",
    "Voter ID",
    "Driving License",
  ],
};

const RegulatoryDetails = ({
  data = {},
  viewOnly = false,
  sx = {},
  onSubmit = () => {},
}) => {
  const [value, setValue] = useState({});
  const [isSubmitActive, setIsSubmitActive] = useState(false);
  const { showToast } = useToaster();
  const caseId = useSelector((state) => state?.CaseDescriptionSlice?.caseId);

  const onChangeHandler = (e) => {
    let { name, value } = e.target;
    setValue((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const onDetailsSubmit = () => {
    if (!isSubmitActive)
      return showToast("Please provide all details.", "warning", true);
    let payload = {
      ...value,
      case_id: caseId,
    };
    regulatoryDetailsPostApi(payload)
      ?.then((response) => {
        if (response?.success) {
          onSubmit();
          showToast(response?.message, "success", true);
        }
      })
      ?.catch((err) => {
        console.log(err?.response?.data?.message);
        showToast(err?.response?.data?.message, "error", true);
      });
  };

  useEffect(() => {
    let formEntries = Object.entries(value);
    let inputFieldsLength = Object.keys(inputFieldNames)?.length;
    let isFieldEmpty =
      formEntries?.length === inputFieldsLength
        ? formEntries?.find((data) => !data[1])
        : true;
    setIsSubmitActive(!isFieldEmpty);
  }, [value]);

  useEffect(() => {
    if (viewOnly) {
      setValue({ ...data });
    }
  }, [viewOnly, data]);

  return (
    <Box sx={sx}>
      <Grid
        container
        spacing={{ xs: 2, md: 3 }}
        columns={{ xs: 4, sm: 8, md: 12 }}
        rowGap={0.8}
      >
        {Object.keys(inputFieldNames)?.map((key, index) => (
          <Grid item xs={2} sm={4} md={4} key={index}>
            {selectFields.includes(key) ? (
              <CustomSelect
                options={selectFieldsOptions?.[key]}
                openSelect={viewOnly ? true : false}
                sx={{ pointerEvents: viewOnly ? "none" : "" }}
                name={inputFieldNames?.[key]}
                label={key}
                labelStyles={{
                  fontSize: "1.3rem",
                  fontWeight: 500,
                  color: "#070A13",
                  marginBottom: "5px",
                  fontStyle: "Inter",
                }}
                placeholder={"Select"}
                height={"33px"}
                border="1px solid rgba(0,0,0,0.12)"
                inputProps={{
                  MenuProps: {
                    PaperProps: {
                      sx: {
                        boxShadow: "none",
                        border: "1px solid rgba(0,0,0,0.12)",
                      },
                    },
                  },
                }}
                customSelectValue={value?.[inputFieldNames?.[key]] || ""}
                handleChange={onChangeHandler}
              />
            ) : (
              <CommonInput
                placeholder={"Enter here"}
                name={inputFieldNames?.[key]}
                label={key}
                labelStyle={{
                  fontSize: "1.3rem",
                  fontWeight: 500,
                  color: "#070A13",
                  marginBottom: "5px",
                  fontStyle: "Inter",
                }}
                removeBackGround
                focusedStyles={{
                  background: "white",
                  border: value ? "1.5px solid #1A8449" : "1.5px solid #CE1821",
                }}
                outlineStyle={{ height: "33px" }}
                value={value?.[inputFieldNames?.[key]] || ""}
                onChange={onChangeHandler}
                readOnly={viewOnly ? true : false}
                sx={{
                  pointerEvents: viewOnly ? "none" : "",
                  input: {
                    "&::placeholder": {
                      textOverflow: "ellipsis !important",
                      color: "#64748B",
                      fontSize: "1.3rem",
                    },
                  },
                }}
              />
            )}
          </Grid>
        ))}
      </Grid>
      {!viewOnly && (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            marginTop: "4rem",
            marginBottom: "1rem",
          }}
        >
          <Button
            variant="contained"
            sx={{
              ":hover": {
                bgcolor: "#e85055",
                color: "white",
              },
              width: "max-content",
              textTransform: "none",
              display: "flex",
              backgroundColor: isSubmitActive
                ? "#e85055"
                : "rgba(232, 80, 91, 0.3)",
              fontSize: "1.2rem",
              padding: "0.8rem 2.7rem",
              boxShadow: "4px 4px 3px rgba(0, 0, 0, 0.25)",
              color: isSubmitActive ? "white" : "#E8505B",
            }}
            onClick={onDetailsSubmit}
          >
            Submit
          </Button>
        </Box>
      )}
    </Box>
  );
};

export default RegulatoryDetails;
